/**
 * Sky's social dashboards: the customer and job they live on, in ONE place.
 *
 * These mirror the constants of the same name in
 * `goapi/pkg/server/sky_social_media.go`. The frontend never SENDS them — the
 * backend route group fixes its own scope and would ignore ours — so their only
 * job here is to decide whether the Social Media menu entry exists at all.
 *
 * They are a module rather than an inline check because a second copy of the
 * predicate is how the menu ends up visible on a job whose dashboards 403, or
 * hidden on the one job they work for.
 */
export const SKY_SOCIAL_CUSTOMER = 'bprsky'

/**
 * Historical name; the job holds TikTok, Instagram, Facebook and X. Renaming it
 * was considered and rejected (it is the Azure container name), so the honest
 * thing is to name it once and explain it here.
 */
export const SKY_SOCIAL_JOB = 'tiktok'

/**
 * Whether the current customer/job is the one Sky's product dashboards serve.
 *
 * Compared case-insensitively because the job selector round-trips names through
 * the licensing server and the URL, neither of which promises case.
 */
export function isSkySocialScope(
  customer: string | undefined | null,
  job: string | undefined | null,
): boolean {
  if (!customer || !job) return false
  return (
    customer.trim().toLowerCase() === SKY_SOCIAL_CUSTOMER &&
    job.trim().toLowerCase() === SKY_SOCIAL_JOB
  )
}

/**
 * (2026-08-24 meeting) Single kill switch for the client-facing "Token spend"
 * entry point on the Sky product dashboards — mirrors the
 * `VOICE_ASSISTANT_ENABLED` pattern in `voice/VoiceAssistantProvider.tsx`.
 * Matt wants no token/spend surface visible to client users before budget
 * conversations happen. Default off. Flip this one flag to re-enable; do not
 * add a second gate elsewhere. This does NOT affect Admin → LLM Usage, which
 * is a separate, still-visible surface.
 */
export const TOKEN_SPEND_VISIBLE = false
